
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22 2v20H2V2h20zm-1.762 5.856H3.8v12.361h16.438V7.856zm-3.321 7.427v1.651h-1.641v-1.651h1.641zm-4.092-.01v1.651h-1.63v-1.651h1.63zm-4.05.01v1.634H7.114v-1.634h1.661zm8.132-4.083v1.641h-1.641V11.2h1.641zm-4.082.01v1.611h-1.63V11.21h1.63zm-4.05-.01v1.621H7.114V11.2h1.661zM8 4a1 1 0 100 2 1 1 0 000-2zm8 0a1 1 0 100 2 1 1 0 000-2z"}})])
          )
        }
      }
    